<div class="dialog-wrapper report-detail-dialog">
  <div class="dialog-header d-flex justify-content-end">
    <button mat-stroked-button (click)="exportCsv()">
      <mat-icon>download</mat-icon>
      {{ 'shared.general.buttons.export_csv' | translate }}
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <av-table-card
      [titleKey]="data.titleKey"
      [icon]="data.icon"
      [columns]="data.columns"
      [rows]="data.rows"
      [pageSize]="10"
    />
  </div>

  <div mat-dialog-actions>
    <div class="dialog-actions">
      <button mat-flat-button color="primary" (click)="close()">
        {{ 'shared.general.buttons.close' | translate }}
      </button>
    </div>
  </div>
</div>
